export const StorageKeys = {
  token: 'Cuerox_Token',
  userContext: 'Cuerox_Usre_Context',
  appContext: 'Cuerox_App_Context',
};
